import React from "react";

const ProcessingBarBlack = () => {
  return (
    <span
      style={{
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: "#ff0000",
        boxShadow: "32px 0 #ff0000, -32px 0 #ff0000",
        position: "relative",
        animation: "flash 0.5s ease-out infinite alternate",
      }}
      className="block"
    />
  );
};

<style>
  {`
    @keyframes flash {
      0% {
        background-color: #000000;
        box-shadow: 32px 0 #000000, -32px 0 #000000;
      }
      50% {
        background-color: #000000;
        box-shadow: 32px 0 #000000, -32px 0 #000000;
      }
      100% {
        background-color: #000000;
        box-shadow: 32px 0 #000000, -32px 0 #000000;
      }
    }
  `}
</style>;

export default ProcessingBarBlack;
